import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import LandingPageComponent from '../landing-page/landing-page-components';
import { LoginPage } from '../login/login-component';
import {HomeScreen} from '../homescreen/homescreen-component';
import {JoinPage} from '../byod-join/byod-join-component';
import {SessionsComponent} from '../sessions/sessions-component';
import {CreateSessionComponent} from '../create-session/create-session-component';
import {PodsOverviewComponent} from '../pods-overview/pods-overview-component';
import {SessionManagerComponent} from '../session-manager/session-manager-component';
import {DiscussionGraphComponent} from '../discussion-graph/discussion-graph-component';
import { SettingsComponent } from '../settings/settings-component';
import { PodComponent } from '../pod-details/pod-component';
import {TranscriptsComponent} from '../transcripts/transcripts-component';
import {PodsComponent} from '../pods/pods-component';
import {ProtectedRoute} from './protected-route';
import {SessionFeedbackForm} from "../feedback-form/session-feedback-form";
import {RagSearchComponent} from '../rag-search/RagSearchComponent';
import { AgentChatPanel, V3ChatPanel, V7ChatPanel } from '../components/agent-chat';
import BaselineAgentChatPanel from '../components/agent-chat/BaselineAgentChatPanel';
import { ExpertAgentRating } from '../expert-agent-rating/expert-agent-rating';
import AppLayout from '../components/app-layout/AppLayout';
import MathLayout from '../components/math/MathLayout';
import ViewerJoinPage from '../viewer/ViewerJoinPage';
import ViewerPage from '../viewer/ViewerPage';
import VoiceprintAdmin from '../components/voiceprint-admin/VoiceprintAdmin';
import VoiceprintRecorder from '../components/voiceprint-recorder/VoiceprintRecorder';
import StudentAppLayout from '../components/student-app/StudentAppLayout';

function PageRouter() {

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPageComponent />} />
                <Route path="/login" element={<LoginPage  />} />
                <Route path="/join" element={<JoinPage />} />
                {/* Viewer devices (no audio capture) — enter group code, land in live view */}
                <Route path="/viewer" element={<ViewerJoinPage />} />
                <Route path="/viewer/:deviceId" element={<ViewerPage />} />
                {/* /home redirects role-scoped accounts inside HomeScreen, but
                    we also gate at the route layer so students never even
                    momentarily see the TA main menu. */}
                <Route path='/home' element={<ProtectedRoute component={HomeScreen} disallowRoles={['student']} />}/>
                {/* All TA dashboard routes — students get bounced to /student-app. */}
                <Route path='/sessions' element={<ProtectedRoute component={SessionsComponent} disallowRoles={['student']}/>}/>
                <Route path='/sessions/new' element={<ProtectedRoute component={CreateSessionComponent} disallowRoles={['student']}/>} />
                <Route path='sessions/:sessionId' element={<ProtectedRoute component={SessionManagerComponent} disallowRoles={['student']}/>} >
                    <Route path='' element={<Navigate to="overview"  />} />
                    <Route path='overview' element={<ProtectedRoute component={PodsOverviewComponent} disallowRoles={['student']}/>} />
                    <Route path='graph' element={<ProtectedRoute component={DiscussionGraphComponent} disallowRoles={['student']}/>} />
                    <Route path='pods/:sessionDeviceId' element={<ProtectedRoute component={PodComponent} disallowRoles={['student']}/>} />
                    <Route path='pods/:sessionDeviceId/transcripts' element={<ProtectedRoute component={TranscriptsComponent} disallowRoles={['student']}/>} />
                </Route>
                <Route path='/pods' element={<ProtectedRoute component={PodsComponent} disallowRoles={['student']}/> } />
                <Route path='/settings' element={<ProtectedRoute component={SettingsComponent} disallowRoles={['student']}/> } />
                <Route path="/feedback-form/:sessionId" element={<SessionFeedbackForm />} />
                <Route path='/discover' element={<ProtectedRoute component={RagSearchComponent} disallowRoles={['student']}/>}/>
                <Route path='/chat-baseline' element={<ProtectedRoute component={BaselineAgentChatPanel} disallowRoles={['student']}/>}/>
                <Route path='/chat-v3' element={<ProtectedRoute component={V3ChatPanel} disallowRoles={['student']}/>}/>
                <Route path='/chat-v7' element={<ProtectedRoute component={V7ChatPanel} disallowRoles={['student']}/>}/>
                <Route path='/expert-agent-rating' element={<ExpertAgentRating />} />
                <Route path='/transcripts/device/:deviceId' element={<TranscriptsComponent />} />
                {/* CS330 voiceprint management (admin-only; component itself enforces) */}
                <Route path='/voiceprints' element={<ProtectedRoute component={VoiceprintAdmin} disallowRoles={['student']}/>} />
                {/* Standalone voiceprint recorder — students record via StudentRightPanel,
                    so this standalone page is also TA-side. */}
                <Route path='/record-voiceprint' element={<ProtectedRoute component={VoiceprintRecorder} disallowRoles={['student']}/>} />
                {/* New two-panel discussion dashboard — TA / study only.
                    AppLayout has an in-component bounce as a backup, but the
                    route-level disallow prevents the brief V7AgentChatPanel
                    flash that students otherwise saw. */}
                <Route path='/app' element={<ProtectedRoute component={AppLayout} disallowRoles={['student']}/>} />
                <Route path='/app/:deviceId' element={<ProtectedRoute component={AppLayout} disallowRoles={['student']}/>} />
                <Route path='/app/:deviceId/:tab' element={<ProtectedRoute component={AppLayout} disallowRoles={['student']}/>} />
                {/* CS330 student layout — separate from /app to keep User Study untouched */}
                <Route path='/student-app' element={<ProtectedRoute component={StudentAppLayout} />} />
                <Route path='/student-app/:deviceId' element={<ProtectedRoute component={StudentAppLayout} />} />
                <Route path='/student-app/:deviceId/:tab' element={<ProtectedRoute component={StudentAppLayout} />} />
                {/* Math Dashboard */}
                <Route path='/math' element={<ProtectedRoute component={MathLayout} />} />
                <Route path='/math/:deviceId' element={<ProtectedRoute component={MathLayout} />} />
                <Route path='/math/:deviceId/:tab' element={<ProtectedRoute component={MathLayout} />} />
                {/* Legacy typo redirect — early builds used /view/ but the canonical
                    viewer route is /viewer/. Keep this so any stale link still works. */}
                <Route path="/view/:deviceId" element={<Navigate to="/viewer" replace />} />
                {/* Catch-all: any unknown URL goes to landing rather than a blank page */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    )
}

export {PageRouter}
